import React from 'react';

export default function CornerPanel({ title, right, children, className = '', active = false, testId }) {
  return (
    <div
      data-testid={testId}
      className={`panel brackets ${active ? 'panel-cyan' : ''} ${className}`}
    >
      <span className="bk-bl" /><span className="bk-br" />
      {(title || right) && (
        <div className="flex flex-wrap items-center justify-between gap-2 px-3 py-2 border-b border-[var(--border-default)]">
          <div className="font-display uppercase tracking-[0.25em] text-[11px] text-cyan-sys min-w-0 truncate">
            {title}
          </div>
          {right && <div className="text-[10px] text-[var(--txt-secondary)] min-w-0">{right}</div>}
        </div>
      )}
      <div className="p-3">{children}</div>
    </div>
  );
}
